import { GeoJSONStoreFeatures } from 'terra-draw';

export type OverlayGeometry = GeoJSONStoreFeatures | google.maps.Rectangle;

export interface DrawResult {
  type: 'rectangle' | google.maps.drawing.OverlayType;
  overlay: OverlayGeometry;
  feature?: GeoJSONStoreFeatures;
}

export interface Snapshot {
  bounds?: google.maps.LatLngBoundsLiteral;
  fillColor?: string;
  fillOpacity?: number;
  coordinates?: number[][];
  featureId?: string;
}

export interface Overlay {
  type: 'rectangle' | google.maps.drawing.OverlayType;
  geometry: OverlayGeometry;
  snapshot: Snapshot;
  featureId?: string;
}

export interface State {
  past: Array<Array<Overlay>>;
  now: Array<Overlay>;
  future: Array<Array<Overlay>>;
}

export enum DrawingActionKind {
  SET_OVERLAY = 'SET_OVERLAY',
  UPDATE_OVERLAYS = 'UPDATE_OVERLAYS',
  REMOVE_OVERLAY = 'REMOVE_OVERLAY',
  INITIALIZE_OVERLAYS = 'INITIALIZE_OVERLAYS',
  UNDO = 'UNDO',
  REDO = 'REDO',
  CLEAR = 'CLEAR',
}

export interface ActionWithTypeOnly {
  type: Exclude<
    DrawingActionKind,
    | DrawingActionKind.SET_OVERLAY
    | DrawingActionKind.REMOVE_OVERLAY
    | DrawingActionKind.INITIALIZE_OVERLAYS
  >;
}

export interface SetOverlayAction {
  type: DrawingActionKind.SET_OVERLAY | DrawingActionKind.REMOVE_OVERLAY;
  payload: DrawResult;
}

export interface InitializeOverlaysAction {
  type: DrawingActionKind.INITIALIZE_OVERLAYS;
  payload: Overlay[];
}

export type Action =
  | ActionWithTypeOnly
  | SetOverlayAction
  | InitializeOverlaysAction;

export function isRectangle(
  overlay: OverlayGeometry
): overlay is google.maps.Rectangle {
  return (
    (overlay as google.maps.Rectangle).getBounds !== undefined &&
    typeof (overlay as google.maps.Rectangle).getBounds === 'function'
  );
}

export function isTerraDrawFeature(
  overlay: OverlayGeometry
): overlay is GeoJSONStoreFeatures {
  return (
    (overlay as GeoJSONStoreFeatures).geometry !== undefined &&
    (overlay as GeoJSONStoreFeatures).type === 'Feature'
  );
}
